<template xmlns="http://www.w3.org/1999/html">
  <div class="main">
    <div style="width: 100%;background-color:rgb(176, 145, 120);height: 100vh;overflow-y: hidden;">
      <div style="width: 100%;background-color:rgb(229, 211, 193);height: 40vh;">

        <div
          style="width:100%;position: fixed;flex-direction: column;align-items: center;justify-content: center;text-align: center;top: 1%;">
          <img src="/static/images/demo/tcpanda.png" alt="" style="width:50%;" />
          <div style="margin-top: -15px;font-size: 16px;">
            防伪查询<br />
            Anti-counterfeiting inquiry
          </div>
          <div style="font-size: 12px;margin-top: 8px;">
            当前查询防伪码
          </div>
          <div style="font-size: 20px;color: white;margin-top: 10px;background-color:rgb(176,145,120);
              width: 75%;height: 35px;margin:5px auto;
              border-radius: 10px;display: flex;align-items: center;justify-content: center;">
            2334 5745 9903 9456
          </div>

        </div>
      </div>



      <div style="position: relative;height: 60vh;top:-20px">
        <div style="font-size: 15px;color: white;background-color:rgba(204,180,163,0.9);
              width: 90%;height: 60vh;
              border-radius: 10px;position: absolute;top: 0;left: 5%;align-items: end;overflow-y: scroll;">
          <div>
          </div style="width:100%;height:100%;position:relative;">
          <!--   -->
          <img src="/static/images/demo/bg-draw.png" alt=""
            style="width:100%;border-radius: 10px;position: absolute;bottom: 0%;left: 50%;transform: translateX(-50%);" />
        </div>


        <div style="font-size: 15px;color: white;background-color:rgba(204,180,163,0.9);
              width: 90%;height: 60vh;
              border-radius: 10px;position: absolute;top: 0;left: 5%;overflow-y: scroll;">


          <div style="width: 100%;display: flex;align-items: center;justify-content: center;">
            <div v-show="istrue" style="width: 90%;text-align: left;font-size: 14px;margin-top: 20px;line-height: 25px;">
              尊敬的用户，您好！<br />
              您所查询的是上海某化妆品有限公司的正品。<br />
              请放心使用。感谢您对品牌的信任与支持!<br /><br />
              查询记录:<br />
              首次查询:2024年05月06日，16时32分
            </div>


            <div v-show="isfalse" style="width: 90%;text-align: left;margin-top: 20px;font-size: 14px;line-height: 25px;">
              尊敬的用户，您好！<br />该防伪码已被多次查询过，该防伪码已失效,警防假冒!<br /><br /><br />
              查询记录:<br />
              首次查询:2024年05月06日，16时32分
            </div>

          </div>

          <div
              style="bottom: 10%;position: absolute;width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;">
              <div style="font-size: 20px;color: white;background-color:rgb(176,145,120);
                        width: 55%;height: 35px;display: flex;flex-direction: column;align-items: center;justify-content: center;
                        border-radius: 10px;">
                <a href="https://shop140904514.m.youzan.com/v2/feature/q2f3pCgEPm">点击进入商城</a>
              </div>
          </div>


        </div>

      </div>

    </div>

  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>


<style scoped>
.text-center {
  width: 100%;
  height: 300px;
  padding: 0px 30px 0px 30px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
<script>
export default {
  data() {
    return {
      istrue: true,
      isfalse: false,
      showKF: false,
    }
  },
  methods: {
    getResult() {
      let data = localStorage.getItem("data")
      if (data == null) {
        data = 0
      }
      data = parseInt(data) + 1
      localStorage.setItem("data", data)
      if (data % 2 != 0) {
        this.istrue = true
        this.isfalse = false
      } else {
        this.istrue = false
        this.isfalse = true
      }
    }
  },
  created: function () {
    this.getResult()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Demo/AntiA.vue